/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NotificationsStatus model module.
 * @module model/NotificationsStatus
 * @version 1.0.0
 */
class NotificationsStatus {
    /**
     * Constructs a new <code>NotificationsStatus</code>.
     * @alias module:model/NotificationsStatus
     */
    constructor() { 
        
        NotificationsStatus.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NotificationsStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NotificationsStatus} obj Optional instance to populate.
     * @return {module:model/NotificationsStatus} The populated <code>NotificationsStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NotificationsStatus();

            if (data.hasOwnProperty('action')) {
                obj['action'] = ApiClient.convertToType(data['action'], 'String');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
            if (data.hasOwnProperty('route')) {
                obj['route'] = ApiClient.convertToType(data['route'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} action
 */
NotificationsStatus.prototype['action'] = undefined;

/**
 * @member {String} message
 */
NotificationsStatus.prototype['message'] = undefined;

/**
 * @member {String} route
 */
NotificationsStatus.prototype['route'] = undefined;






export default NotificationsStatus;

